<template>
	<template v-if="isAuthed">
		<template v-if="inPil">
			<div class="pil">
				<div class="pil-heading">
					<strong>Admin {{ allowEf ? '& EF ' : '' }}only</strong>
				</div>
				<div>
					<slot />
				</div>
			</div>
		</template>
		<template v-else>
			<slot />
		</template>
	</template>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { useUser } from '@/stores/userStore';
import { mapState } from 'pinia';

export default defineComponent({
	props: {
		inPil: {
			type: Boolean,
			default: false,
		},
		allowEf: {
			type: Boolean,
			default: false,
		},
	},
	computed: {
		isAuthed() {
			if (this.isAdmin) {
				return true;
			}

			if (this.allowEf && this.isEf) {
				return true;
			}

			return false;
		},

		...mapState(useUser, ['isAdmin', 'isEf']),
	},
});
</script>

<style scoped lang="scss">
.pil {
	margin: 10px 0;
	border-radius: var(--rs-border-radius);
	background-color: rgb(var(--rs-color-brand-grey-text));
	padding: 10px;

	.pil-heading {
		margin-bottom: 10px;
	}
}
</style>
